import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField, InputAdornment } from "@mui/material";
import { EmailOutlined } from "@mui/icons-material";

const ForgotPassword = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="authBox">
        <h2 style={{ position: "relative" }}>
          <img
            src="/static/images/back_arrow.svg"
            alt="back"
            onClick={() => navigate(-1)}
            className="back_arrow"
            style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", cursor: "pointer", width: 24, height: 24 }}
          />
          Forgot Password?
        </h2>
        <p className="subtitle" style={{ marginBottom: 40 }}>
          Enter your email to request a reset link
        </p>

        <form className="form">
          <div className="control_group text_field">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email address"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlined style={{ color: "rgba(255, 255, 255, 0.4)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="form_btn" style={{ marginTop: 30 }}>
            <Button
              className="btn btn_primary w_100"
              onClick={() => navigate("/recoverymail")}
            >
              Reset Password
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
